/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type AuthenticationMethod =
  (typeof AuthenticationMethod)[keyof typeof AuthenticationMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthenticationMethod = {
  None: 0,
  Email: 1,
  MobileNumber: 2,
  DateOfBirth: 3,
} as const;
